const changeVisibleElement = (setVisibleElement,visibleElement) =>{
  setVisibleElement(!visibleElement);
}

export {changeVisibleElement};